<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.productNames"
              placeholder="请输入品规名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun"
        @edit="editFun(arguments)"
        @delete="deleteFun(arguments)"
        @view="viewFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>
    <!-- 新增 修改-->
    <add-edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 新增 修改
import addEditViewDialog from './components/addEditViewDialog'
// 数据请求
import { loadRetailMonitoringProductDataRangeListDataApi, loadRetailMonitoringProductDataRangeExportDataApi, saveOrUpdateRetailMonitoringProductDataRangeApi } from '@/api/retailMonitoringProductDataRange'
export default {
  name: 'RetailMonitoringProductDataRange',
  components: {
    CustomTable,
    TableOperation,
    addEditViewDialog
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'base_retail_monitoring_product_data_range_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['retail_monitoring_product_data_range_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['retail_monitoring_product_data_range_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['retail_monitoring_product_data_range_delete'],
            prop: 'delete',
            label: '删除',
            method: 'delete'
          },
          {
            permissionSigns: ['retail_monitoring_product_data_range_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['retail_monitoring_product_data_range_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            productName: ''
          }
        },
        notPaging: true
      },
      id: null, // 选中的单据ID
      dialogSetPersmissionVisible: false, // 设置权限
      dialogAddEditVisible: false,
      dialogAddEditTitle: '',
      eventType: ''
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'productName', label: '省区', filterColumn: 'product_name', width: 150 },
      { prop: 'minStorageAmount', label: '最小库存数量', filterColumn: 'min_storage_amount', width: 150 },
      { prop: 'maxStorageAmount', label: '最大库存数量', filterColumn: 'max_storage_amount', width: 150 },
      { prop: 'minArrivalAmount', label: '最小到货数量', filterColumn: 'min_arrival_amount', width: 150 },
      { prop: 'maxArrivalAmount', label: '最大到货数量', filterColumn: 'max_arrival_amount', width: 150 },
      { prop: 'minPrice', label: '最小本码出货价', filterColumn: 'min_price', width: 150 },
      { prop: 'maxPrice', label: '最大本码出货价', filterColumn: 'max_price', width: 150 },
      { prop: 'remark', label: '备注' },
      { prop: 'operatorName', filterColumn: 'operator_name', label: '操作人', width: 120 },
      { prop: 'operationTimeStr', filterColumn: 'operation_time', label: '操作时间', width: 180, isBetween: true }
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.masterList.tableQuery) }
      loadRetailMonitoringProductDataRangeListDataApi(pageCondition).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    //新增
    addFun () {
      this.eventType = 'add'
      this.dialogAddEditVisible = !this.dialogAddEditVisible
      this.dialogAddEditTitle = '新增零售监测调查品规数据范围限制'
    },
    // 修改
    editFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'edit'
      this.dialogAddEditVisible = !this.dialogAddEditVisible
      this.dialogAddEditTitle = '修改零售监测调查品规数据范围限制'
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.id = args[0].id
      this.eventType = 'view'
      this.dialogAddEditVisible = !this.dialogAddEditVisible
      this.dialogAddEditTitle = '查看零售监测调查品规数据范围限制'
    },
    // 删除
    deleteFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确定删除该调查品规数据范围限制？', '系统提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }
      ).then(async () => {
        saveOrUpdateRetailMonitoringProductDataRangeApi({ id: args[0].id, isDelete: "1" }).then(res => {
          if (res.mark === '200') {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 导出数据API
    ExportByPage () {
      let pageCondition = { condition: JSON.stringify(this.exportObj) }
      loadRetailMonitoringProductDataRangeExportDataApi(pageCondition).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
